<template>
  <div class="grid-container post-purchase-home small-padding-top-s medium-padding-top-xl small-padding-bottom-xxl medium-padding-bottom-xxxl">
    <slot></slot>
  </div>
</template>

<script setup>
/* istanbul ignore file */
</script>
